import { Text } from '@doist/marketist';
import css from './blockquote.module.css';
export function Blockquote({
  children
}: {
  children: React.ReactNode;
}) {
  return <Text tag="blockquote" className={css.blockquote} data-sentry-element="Text" data-sentry-component="Blockquote" data-sentry-source-file="blockquote.tsx">
            {children}
        </Text>;
}